<template>
<v-card>
  <v-card-title>
    <v-flex xs10>
      <span style="font-size:16px">
        <b>
          {{ relatedValue.name }}
        </b>
      </span>
    </v-flex>
    <v-flex xs1>
      <v-dialog width="700">
        <template v-slot:activator="{on}">
          <v-icon v-if="editEnable" block color="black darken-2" fab small
                  @click="showDialog($event,on)">qr_code_2
          </v-icon>
        </template>
        <v-sheet>
          <h3 style="text-align: center;padding-top: 1rem;">Kod QR: {{ relatedValue.code }}</h3>
          <v-progress-linear v-if="qrcode.length == 0" indeterminate></v-progress-linear>
          <div v-else style="padding: 1rem">
            <img id="relatedValueQrcode" :src="qrcode" style="margin: auto;display: block;"/>
            <v-btn color="blue" style="margin: auto;display: block;" @click="download()">Pobierz</v-btn>
          </div>
        </v-sheet>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-icon v-if="editEnable" block color="green darken-2" fab small style="color: #efefef;"
              @click='$emit("edit",{})'>edit
      </v-icon>
    </v-flex>
  </v-card-title>
  <v-divider></v-divider>

  <v-list dens>
    <v-list-tile>
      <v-list-tile-content>{{$t('related.code')}}</v-list-tile-content>
      <v-list-tile-content class="align-end">{{ relatedValue.code }}</v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-for="(keyObj,index) in relatedSchema.keys" :key="index">
      <v-list-tile-content>{{ keyObj.name }}:</v-list-tile-content>
      <v-list-tile-content class="align-end">{{ getValue(keyObj) }}</v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-divider></v-divider>
  <slot name="actions">
    <v-card-actions v-if="deleteEnabled" class="justify-center">
      <v-btn flat @click="$emit('delete', relatedValue)" color="orange">{{$t('related.delete')}}</v-btn>
    </v-card-actions>
  </slot>
</v-card>
</template>
<script>

export default {
  props: ['deleteEnabled', 'relatedValue', 'relatedSchema', 'editEnable'],
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      qrcode: ""
    }
  },
  methods: {
    getValue(key) {
      let valueObj = this.relatedValue.values.find(el => el.order == key.order)
      return valueObj ? valueObj.value : ""
    },
    showDialog(event, on) {
      on.click(event)
      this.getQrCode()
    },
    getQrCode() {
      if (this.qrcode.length > 0) {
        return
      }

      this.$http.get('related/schema/' + this.relatedSchema.id + '/values/' + this.relatedValue.id + '/qrcode').then(data => {
        this.qrcode = data.data
      })
    },
    download() {
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")
      var src = this.qrcode

      var image = new Image()
      image.onload = () => {
        canvas.height = image.height + 40
        canvas.width = image.width
        ctx.fillStyle = "white"
        ctx.fillRect(0, 0, image.width, image.height + 40)
        ctx.fillStyle = "black"
        ctx.fillText(this.relatedValue.code, this.getTextWidth(image, ctx), 15, image.width)

        ctx.drawImage(image, 0, 20, image.width, image.height)
        var img = new Image()
        img.src = canvas.toDataURL()

        var link = document.createElement('a')
        link.download = this.relatedValue.code
        link.href = canvas.toDataURL()
        link.click()
      }

      image.src = src
    },
    getTextWidth(qrcodeImg, ctx) {
      let textMeasure = ctx.measureText(this.relatedValue.code).width
      if ((qrcodeImg.width - textMeasure) < 0) {
        return 0
      }

      return (qrcodeImg.width - textMeasure) / 2
    }
  }
}
</script>

<style>
</style>
